//@flow
import BaseComponent from '../base_component/base_component'

export default class AboutUs extends BaseComponent {

    constructor(id: number, component_name: string) {
        super(id, component_name);
        this.navActivate();
    }

    navActivate() {
        $(this.component).find('.holder-about .nav-open').click(function (){
            if ($(this).hasClass('rotate-180')) {
                $('.holder-about .screen-this').fadeOut();
                $('.holder-about .nav-open').removeClass('rotate-180');
                $('.about-nav').removeClass('about-nav-expand');
            }	else {
                $('.holder-about .screen-this').fadeIn();
                $('.holder-about .nav-open').addClass('rotate-180');
                $('.about-nav').addClass('about-nav-expand');
                if ($('.holder-about .nav-open').hasClass('rotate-180')) {
                    $('.holder-about .nav-slice').click(function() {
                        $('.holder-about .screen-this').fadeOut();
                        $('.holder-about .nav-open').removeClass('rotate-180');
                        $('.holder-about .about-nav').removeClass('about-nav-expand');
                    });
                }
            }
        });
    }

}
